<template>
  <div class="container">
    <div class="title is-4 mb-2">{{ $t("classroom detail") }}</div>
    <form>
      <div class="field">
        <label class="label">{{ $t("virtual address") }}</label>
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="meta.virtual_address"
            placeholder="https://meet.google.com/abc-defg-hij"
          />
        </div>
      </div>
    </form>
    <pre>{{ classroom }}</pre>
  </div>
</template>

<script>
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  get,
  error_message,
  format_currency,
  input_alert,
} from "@/utils";

export default {
  name: "ClassroomDetail",
  components: {},
  data() {
    return {
      classroom: null,
      meta: {},
    };
  },
  computed: {},
  methods: {
    set_classroom(classroom) {
      let v = this;
      get("/student/my-classroom", { uuid: classroom.uuid })
        .then((response) => {
          v.classroom = response;
        })
        .catch((error) => {
          error_message(error);
        });
    },
  },
};
</script>

<style scoped>
.section {
  padding-top: 2rem;
}
.box {
  margin-bottom: 1rem;
}
</style>
